import React from 'react';

export default function StartTalentAssessment() {
  return (

    <>
      <h1>Health and Performance Assessment</h1>

      <p className="mt-5">
        This assessment is uniquely designed to measure where you currently
        fall on 12 key dimensions affecting your work readiness.
        Your results, available immediately, will provide invaluable insights as
        you prepare for workplace reintegration.
      </p>
    </>

  );
}
